import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=ec7e437c"
import script from "./NewEdit.vue?vue&type=script&lang=js"
export * from "./NewEdit.vue?vue&type=script&lang=js"
import style0 from "./NewEdit.vue?vue&type=style&index=0&id=ec7e437c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports